// extracted by mini-css-extract-plugin
export var container = "_8f-0";
export var icon = "_8f-1";
export var text = "_8f-2";